<template>
  <b-form>
    <b-form-group :label="$gettext('Name')" label-class="gk-label-margin gk-modal-label" label-for="name">
      <b-form-input id="name" v-model="value.name" required></b-form-input>
    </b-form-group>

    <GekkoButton
      @click="moreDetails()"
      :text="$gettext('More')"
      :icon="moreAccordion ? 'fa-solid fa-caret-down' : 'fa-solid fa-caret-right'"
      variant="link"
      class="text-blue px-0"
      size="sm"
      icon-right
    />

    <b-collapse v-model="moreAccordion">
      <b-card-body>
        <b-row>
          <b-col>
            <b-form-group :label="$gettext('Country')" label-class="gk-label-margin gk-modal-label" label-for="country">
              <b-form-select
                :options="countries"
                v-model="value.country"
                :placeholder="$gettext('Netherlands')"
              ></b-form-select>
              <div v-if="isCountryInvalid" class="text-danger small mt-1">
                {{ $gettext('Please select a country.') }}
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="$gettext('Tax ID')" label-class="gk-label-margin gk-modal-label" label-for="tax_id">
              <b-form-input id="tax_id" v-model="value.tax_id"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group :label="$gettext('City')" label-class="gk-label-margin gk-modal-label" label-for="city">
              <b-form-input id="city" v-model="value.city"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              :label="$gettext('Postal code')"
              label-class="gk-label-margin gk-modal-label"
              label-for="postal_code"
            >
              <b-form-input id="postal_code" v-model="value.postal_code"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group :label="$gettext('Address')" label-class="gk-label-margin gk-modal-label" label-for="address">
              <b-form-input id="address" v-model="value.address"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-collapse>
  </b-form>
</template>

<script>
import { mapGetters } from 'vuex'
import GekkoButton from '@/components/GekkoButton'

export default {
  name: 'NewSupplierForm',
  components: {
    GekkoButton,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      moreAccordion: false,
    }
  },
  computed: {
    ...mapGetters({
      countries: 'main/getCountryOptions',
    }),
    isCountryInvalid() {
      return !this.value.country || this.value.country === '.'
    }
  },
  mounted() {
    if (this.isCountryInvalid) {
      this.moreAccordion = true
    }
  },
  methods: {
    moreDetails() {
      this.moreAccordion = !this.moreAccordion
    },
    assignTaxIdFields() {
      const taxId = (this.value.tax_id || '').trim()
      const hasCountryCodePrefix = /^[A-Za-z]{2}/.test(taxId)

      this.value.btw = hasCountryCodePrefix ? taxId : ''
      this.value.kvk = hasCountryCodePrefix ? '' : taxId
    },
  },
}
</script>

<style lang="scss">
.mastermodal-view--right {
  z-index: auto !important;
}
</style>

<style lang="scss" scoped>
.subtitle-text {
  font-size: 16px;
  color: $colorTextLight;
}

.card-body {
  padding-left: 0;
  padding-right: 0;
}
</style>